@if (step() === 'select') {
  <div class="select-payment-heading">
    <span class="title-large-emphasized">{{ 'orders.ui.selezionaMetodoDiPagamento' | transloco }}</span>
    <span class="label-large">{{ type === 'Oil' ? 'OIL' : 'NON OIL' }}</span>
  </div>

  <mat-radio-group class="payment-options" [value]="selectedId()" (change)="onSelectOption($event.value)">
    @for (option of options(); track option.value) {
      <div class="payment-option" [class.payment-option--selected]="selectedId() === option.value">
        <mat-radio-button [value]="option.value">{{ optionLabel(option) }}</mat-radio-button>
      </div>
    }
  </mat-radio-group>

  <div class="buttons-container">
    <button matButton type="button" (click)="cancel()">{{ 'orders.ui.annulla' | transloco }}</button>
    <button matButton="filled" type="button" [disabled]="!selectedId() || saving()" (click)="continue()">{{ 'orders.ui.continua' | transloco }}</button>
  </div>
} @else {
  <div class="select-payment-heading">
    <span class="title-medium">{{ 'orders.ui.metodoDiPagamentoSelezionato' | transloco }}</span>
    <div class="selected-payment">
      <div class="selected-payment-icon">
        <i [class]="selectedOption()?.type === 'ABICAB' ? 'fa-regular fa-file-signature' : 'fa-regular fa-hand-holding-dollar'"></i>
      </div>
      <span class="title-medium">{{ selectedOption()?.label }}</span>
    </div>
  </div>

  @if (selectedOption()?.type === 'ABICAB') {
    <div class="payment-details-form">
      <span class="title-medium payment-details-title">{{ 'orders.ui.datiBancari' | transloco }}</span>

      <mat-form-field appearance="outline">
        <mat-label>ABI</mat-label>
        <input matInput [formControl]="abiControl" [matAutocomplete]="abiAuto">
        <i matSuffix class="fa-regular fa-magnifying-glass"></i>
        <mat-autocomplete #abiAuto="matAutocomplete" (optionSelected)="selectAbi($event.option.value)">
          @for (bank of abiOptions(); track $index) {
            <mat-option [value]="bank">
              <span class="body-large">{{ bank.abi }} - {{ bank.banca }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>CAB</mat-label>
        <input matInput [formControl]="cabControl" [matAutocomplete]="cabAuto">
        <i matSuffix class="fa-regular fa-magnifying-glass"></i>
        <mat-autocomplete #cabAuto="matAutocomplete" (optionSelected)="selectBank($event.option.value)">
          @for (branch of cabOptions(); track $index) {
            <mat-option [value]="branch">
              <span class="body-large">{{ branch.cab }} - {{ branch.descrizione }}</span>
              <span class="body-small branch-detail">{{ 'orders.ui.abi' | transloco: { value0: (branch.banca), value1: (branch.abi) } }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'orders.ui.banca' | transloco }}</mat-label>
        <input matInput [formControl]="bancaControl" [matAutocomplete]="bancaAuto">
        <i matSuffix class="fa-regular fa-magnifying-glass"></i>
        <mat-autocomplete #bancaAuto="matAutocomplete" (optionSelected)="selectBank($event.option.value)">
          @for (branch of bancaOptions(); track $index) {
            <mat-option [value]="branch">
              <span class="body-large">{{ branch.banca }}</span>
              <span class="body-small branch-detail">{{ 'orders.ui.abiCab' | transloco: { value0: (branch.abi), value1: (branch.cab), value2: (branch.descrizione) } }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  } @else {
    <div class="payment-details-form">
      <span class="title-medium payment-details-title">{{ 'orders.ui.inserisciContattoTelefonico' | transloco }}</span>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'orders.ui.contattoTelefonico' | transloco }}</mat-label>
        <input matInput type="tel" inputmode="numeric" [formControl]="phoneControl">
        <mat-hint>{{ 'orders.ui.obbligatorio' | transloco }}</mat-hint>
      </mat-form-field>
    </div>
  }

  <div class="buttons-container">
    <button matButton type="button" (click)="cancel()">{{ 'orders.ui.annulla' | transloco }}</button>
    <button
      matButton="filled"
      type="button"
      [disabled]="saving() || (selectedOption()?.type === 'ABICAB' ? !bankComplete : !phoneControl.value)"
      (click)="confirmDetails()"
    >
      {{ 'orders.ui.conferma' | transloco }}
    </button>
  </div>
}
